import React, { useState } from 'react'
import { TABLET_SIZE } from '../../../../../core/constants/common';
import { useWindowSize } from '../../../../../core/hooks/common/useWindowSize';
import CardsTransferTable from './CardTransferTable';
import FilterLayout from '../../../../layout/filter/FilterLayout';
import { useGetCardsTransfers } from '../../../../../core/services/react-query/report/cards';
import { CacheKeys, cardsTransferOptions } from '../../../../../core/constants/filter';
import RCardsTransferTable from './RCardTransferTable';

const CardsTransfers = () => {
    const { width } = useWindowSize();
    const [transfers, setOrders] = useState({ loading: true, data: null })
    const onQuerySuccess = (res) => {
        setOrders(res)
    }

    const Component = width > TABLET_SIZE ? CardsTransferTable : RCardsTransferTable


    return (

        <FilterLayout
            query={useGetCardsTransfers}
            options={cardsTransferOptions}
            onQuerySuccess={onQuerySuccess}
            cache={CacheKeys.CARDS_TRANSFER}
        >
            <Component
                data={transfers}
            />
        </FilterLayout>
    )
}

export default CardsTransfers